export const GET_PERMISSIONS = 'GET_PERMISSIONS';
